import { render } from "./CartTableWrapper.vue?vue&type=template&id=ed2fa666"
import script from "./CartTableWrapper.vue?vue&type=script&lang=js"
export * from "./CartTableWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__